import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=5b4153be&"
import script from "./Sold.vue?vue&type=script&lang=ts&"
export * from "./Sold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports